exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inline{display:inline-block;margin-right:20px;margin-bottom:15px}.btn_newFlicker+.btn_newFlicker{margin-left:0}.flickerTitle{width:40%}.flickerZhouqi{width:20%}.qizhiDate{display:inline-block;width:100%}.flickerContent{width:98%}.newFlicker .el-form-item .el-radio{display:block;margin-left:0;width:200px}.newFlicker .wxApp-from{margin-left:120px;margin-bottom:10px}.newFlicker .wxApp-from .el-input,.wxApp-from-1 .el-input{width:60%}.bannerContent{min-width:700px;width:70%}.newFlicker .irregular{display:inline-block}.gray{color:#999}.newFlicker .time{display:inline-block;width:15%}.flickerContent{min-width:700px;width:70%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-509c0420!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/flicker/newFlickerScreen.vue
// module id = 531
// module chunks = 0